import React from "react";
import "./hallAddInfoSection.scss";

type Props = {
    addInfos: string[];
};

const getAddInfoStr = (virginRoadHeight: string) => {
    let value = "";
    switch (virginRoadHeight) {
        case "DOG_FLOWER":
            value = "애견화동";
            break;
        case "SINGLE_HALL":
            value = "단독홀";
            break;
        case "CURVE_VIRGIN_ROAD":
            value = "곡선 버진로드";
            break;
        case "FLOWER_WRAPPING":
            value = "플라워 랩핑";
            break;
        case "LARGE_SCREEN":
            value = "대형스크린";
            break;
        case "CUSTOMIZING":
            value = "커스터마이징";
            break;
        case "FIRST_BIRTHDAY_PARTY_BANQUET":
            value = "돌잔치/연회";
            break;
        case "SMALL_CEREMONY":
            value = "소규모 예식";
            break;
    }
    return value;
};

export default function HallAddInfoSection({ addInfos }: Props) {
    return (
        <section className="add-info-container">
            <h2>추가정보</h2>
            <ul className="add-info-wrap">
                {addInfos.map((info, i) => (
                    <li key={i}>
                        <p>{getAddInfoStr(info)}</p>
                    </li>
                ))}
            </ul>
        </section>
    );
}
